import React from 'react'
import { clearSession } from '../Interceptors/axios'
import { FiLogOut } from 'react-icons/fi'

const Header = ({ showLogout = true }) => {
const SvgLogout = ({ size = 24, title = "Logout", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    aria-label={title}
    className={className}
  >
    {/* דלת */}
    <path d="M4 4h8a2 2 0 0 1 2 2v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 15v3a2 2 0 0 1-2 2H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* חץ יציאה ימינה */}
    <path d="M10 12h9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 8l4 4-4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
    return (
        <header className='bg-PraimeryBlue w-full p-4 flex items-center justify-center relative' style={{direction:"rtl"}}>

            {/* כפתור יציאה */}
            {showLogout && (
                <button 
                    onClick={clearSession} 
                    className="text-LightOrange absolute right-4 hover:text-red-400 transition"
                    title="התנתק"
                >
                    <SvgLogout/>
                   
                </button>
            )}

            {/* כותרת */}
            <div className='text-center'>
                <p className='text-LightOrange font-light text-sm'>מחקר כוויות ילדים</p>
                <p className='text-LightOrange text-lg font-extrabold'>BGU</p>
            </div>
        </header>
    )
}

export default Header
